import { useCallback } from "react";
import { useQueryClient } from "react-query";
import PropTypes from "prop-types";
import { useGlobalPrivateChannelListener } from "../Hooks/useGlobalPrivateChannelListener";

export const TaskRealtime = ({ id, projectId }) => {
  const queryClient = useQueryClient();

  const listener = useCallback(
    ({ project_id = 0 }) => {
      if (projectId === project_id) {
        queryClient.invalidateQueries(["task-page-navigation", project_id, id]);
      }
    },
    [projectId, queryClient, id]
  );

  useGlobalPrivateChannelListener("TaskCreated", listener);
  useGlobalPrivateChannelListener("TaskMovedToProject", listener);
  useGlobalPrivateChannelListener("TaskRemovedFromProject", listener);
  useGlobalPrivateChannelListener("TaskUpdated", listener);
  useGlobalPrivateChannelListener("TaskCompleted", listener);
  useGlobalPrivateChannelListener("TaskReopened", listener);
  useGlobalPrivateChannelListener("TaskMovedToTrash", listener);
  useGlobalPrivateChannelListener("TaskRestoredFromTrash", listener);
  useGlobalPrivateChannelListener("TaskListMovedToTrash", listener);
  useGlobalPrivateChannelListener("TaskListRestoredFromTrash", listener);
  useGlobalPrivateChannelListener("TaskListChanged", listener);
  useGlobalPrivateChannelListener("TaskReordered", listener);
  useGlobalPrivateChannelListener("TaskListReordered", listener);

  return null;
};

TaskRealtime.propTypes = {
  id: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
};
